module.exports = __webpack_public_path__ + "img/Prize-title@2x.e678f6b6.png";